<span class="productMapper">
   <section
      class="p-2"
      *ngIf="state$ | async as state">
      <div class="d-flex flex-row mb-2">
         <div
            class="flex-column ml-2 byVetcorProductSelect"
            style="max-width: 350px; min-width: 350px">
            <div>
               <!--Filter by VetCor product:-->
               <vc-product-tree-select
                  class="w-100 product-tree"
                  [pimsProduct]="undefined"
                  [initialValue]="state.selectedVCProductSKey"
                  [allProducts]="(hierarchicalProducts$ | async) || undefined"
                  (onChanged)="onVCProductSelected($event.newValue)"></vc-product-tree-select>
            </div>
         </div>

         <div
            class="flex-column ml-2 v-dropdown-sm"
            style="max-width: 300px"
            [ngStyle]="{ opacity: state.selectedVCProductSKey ? '1' : '0.3' }">
            <p-dropdown
               [filter]="true"
               [options]="yourCatList"
               (onChange)="onCategoryChanged($event.value)"
               placeholder="Your Category"
               [class.categoryFilterDrop]="true"
               [showClear]="true"
			   [class.v-categoryfilter]="true"
               (onClear)="onCategoryClear()"></p-dropdown>
         </div>

         <div
            class="flex-column ml-2 v-dropdown-xs"
            style="max-width: 165px"
            [ngStyle]="{ opacity: state.selectedVCProductSKey ? '1' : '0.3' }">
            <p-dropdown
               [options]="productTypes"
               (onChange)="onProductTypeChanged($event.value)"
               optionLabel="productTypeName"
               [class.typeFilterDrop]="true"
               placeholder="Type"
			   [class.v-typefilter]="true"
               [showClear]="true"></p-dropdown>
         </div>

         <div
            class="flex-column ml-2 v-searchbox-sm v-productfilter"
            [ngStyle]="{ opacity: state.selectedVCProductSKey ? '1' : '0.3' }">
            <input
               pInputText
               placeholder="Product Name..."
               [(ngModel)]="searchTextInput"
               (input)="onSearch()" />
         </div>

         <div
            class="flex-column ml-2 v-searchbox-xs v-codefilter"
            [ngStyle]="{ opacity: state.selectedVCProductSKey ? '1' : '0.3' }">
            <input
               pInputText
               [(ngModel)]="searchCodeInput"
               (input)="onSearchCode()"
               ngModelOptions="{standalone: true}"
               name="searchCodeInput"
               placeholder="Your Code..." />
         </div>
      </div>

      <div
         *ngIf="state.selectedVCProductSKey"
         class="flex-column ml-2 align-self-center onlyFilters"
         style="display: flow; float: right; margin-bottom: -32px; justify-content: end; padding-top: 10px">
         <p-checkbox
            [ngModel]="state.missingPracticesVisible"
            [binary]="true"
            (onChange)="setMissingPracticesVisible($event)"
            [class.vcListCheckbox]="true"
            inputId="missingPracticesVisible"></p-checkbox>
         <label
            for="missingPracticesVisible"
            class="mb-0 ml-1">
            Show only unmapped practices
         </label>
      </div>

      <div
         class="d-flex flex-row"
         style="width: 100%">
         <div
            class="flex-column flex-1 align-items-center"
            style="margin-top: 5px; width: 100%"
            [class.loading]="(loading$ | async) || state.loadingPIMS">
            <vc-spinner *ngIf="(loading$ | async) || state.loadingPIMS"></vc-spinner>
            <div
               class="viewport"
               *ngIf="!(loading$ | async) && !state.loadingPIMS">
               <div
                  class="alert alert-info text-center"
                  *ngIf="!state.selectedVCProductSKey">
                  Please select a Vetcor product above.
               </div>
               <vc-product-pims-list
                  *ngIf="state.selectedVCProductSKey"
                  [vcProductSKey]="state.selectedVCProductSKey"
                  [showPracticeColumn]="true"
                  [rows]="state.pimsRows"
                  [virtualScrollItemSize]="100"
                  pimsProductEditable="true"></vc-product-pims-list>
            </div>
         </div>
      </div>
   </section>
   <vc-spinner *ngIf="!(state$ | async)"></vc-spinner>
   <vc-products-feedback />
</span>
